import { MapObject } from "./map-object";

export class Note extends MapObject {

    constructor(
        public idnote:number,
        public ispublic:boolean,
        public title:String,
        public description:String,
        public loctitle:String,
        public loclon:number,
        public loclat:number,
        public localt:number,
        public datefrom:String,
        public dateto:String,
        public urlimage:String,
        public urllink:String,
        public source:String
    ) {
        super(idnote, loclon, loclat, title)
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/note.ts